module.exports = "/_next/static/images/Hero@2x-d5ac98103e06f5bfd30e9ad8dd2fca94.webp";